<div class="report-shell">
  @if (mobileSidebarOpen) {
    <button
      type="button"
      class="report-shell__backdrop"
      aria-label="Close sidebar"
      (click)="closeMobileSidebar.emit()"
    ></button>
  }

  <aside
    class="report-shell__sidebar"
    [class.report-shell__sidebar--collapsed]="sidebarCollapsed"
    [class.report-shell__sidebar--mobile-open]="mobileSidebarOpen"
  >
    <app-dashboard-sidebar [collapsed]="sidebarCollapsed" />
  </aside>

  <div class="report-shell__content">
    <app-dashboard-header
      [title]="''"
      [subtitle]="''"
      [user]="user"
      [currentTime]="currentTime"
      (menuToggle)="menuToggle.emit()"
    />

    <ng-content></ng-content>
  </div>
</div>
